/*
 *   File : confirmation.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Delete Modal
 *   Integrations : 09-02-2022
 *   Version : v1.0
 */

/*import packages*/
import React, { useEffect, useState } from 'react';
import $ from 'jquery';

/*import componets*/
import { SecondaryBtn, PrimaryBtn, TextBtn } from '../../components/cta/index';
import { Toast } from '../note/index';
import { Input } from '../input';

/*import styles*/
import styles from '../../styles/components/confirmation.module.scss';

import Delete from '../../assets/images/modal/delete-icon.png'


/*import services*/
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';

/* import assets */


export default function AddVersionTag(props) {

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loader, setLoader] = useState(false);
    const [tagList, setTagList] = useState([""]);

    useEffect(() => {
        var myModalEl = document.getElementById("addVersionTag")
        myModalEl.addEventListener('hidden.bs.modal', (event) => {

            $(".fade").removeClass("modal-backdrop");
            $("body").removeAttr("style");
            props.modalClose();
        })
        //eslint-disable-next-line
    }, [])

    /* --- close delete modal on click ---*/
    const closeModal = () => {
        $(".btn-close").trigger("click");
        $("#addVersionTag").trigger('click');
    }

    const _updateTag = (value, index) => {
        let temp_array = [...tagList];
        temp_array[index] = value;
        setTagList(temp_array);
    }

    const _addNewEntry = () => {
        let temp_array = [...tagList];
        temp_array.push("");
        console.log('temp_array', temp_array)
        setTagList(temp_array);
    }

    const _removeTag = (index) => {
        let temp_array = [...tagList];
        temp_array.splice(index, 1);
        setTagList(temp_array);
    }

    const _validateEntry = () => {
        if (!Array.isArray(tagList) || tagList.length === 0) {
            return setError("Please add at least one tag");
        }
        const hasInvalid = tagList.some(item => !item?.trim());

        if (hasInvalid) {
            return setError("All inputs should be filled");
        }

        _addVersion();
    };

    const _addVersion = () => {
        setLoader(true);
        let url = devconfig.admin + '/rebalance/add-version-tag';
        let payload = JSON.stringify({
            version_id: props.data.version_id,
            tag_list: tagList
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setSuccess('Version tag updated');
                closeModal();
                props.success();
            } else {
                setError(response.message);
            }
            setLoader(false);
        })
    }

    return (
        <div className={`${styles.e_confirmation} modal fade`} id="addVersionTag" tabIndex="-1" aria-labelledby="success" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header pt-2 pb-0">
                        <h5>Add Tags List to {props.data.version}</h5>
                        <button type="button"
                            className="btn-close"
                            id="close-btn"
                            data-bs-dismiss="modal"
                            aria-label="Close" >
                        </button>
                    </div>
                    <div className="container px-3">

                        <div>
                            {
                                tagList.map((item, key) => {
                                    return (
                                        <div className='row'>
                                            <div className='col-10 mb-2' key={key}>
                                                <Input
                                                    placeholder="Eg: Tag - 1"
                                                    type="text"
                                                    value={item}
                                                    valueChange={(value) => {
                                                        _updateTag(value, key)
                                                    }}
                                                />
                                            </div>
                                            {
                                                key > 0 && (
                                                    <div className='col-2 ms-0 ps-0 mt-2'>
                                                        <div className='version-delete'>
                                                            <img src={Delete} 
                                                                onClick={()=>_removeTag(key)}/>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className='row'>
                            <div className='co1-12 text-end'>
                                <TextBtn name="Add new tag"
                                    handleClick={_addNewEntry} />
                            </div>
                        </div>
                        <div className="row pt-4 pb-2">
                            <div className="col-lg-12">
                                <div className="d-flex justify-content-center gap-2">
                                    <SecondaryBtn name="Cancel" className={styles.e_cancel} cancel="modal" />
                                    <PrimaryBtn name="Submit"
                                        handleClick={_validateEntry}
                                        className={loader === true ? "e-modal-submit e-btn-loader" : "e-modal-submit"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* error toast */}
            {
                error !== null ?
                    <Toast data={error}
                        type="error"
                        id="1"
                    />
                    :
                    null
            }
            {/* success toast */}
            {
                success !== null ?
                    <Toast data={success}
                        type="success"
                        id="2"
                    />
                    :
                    null
            }
        </div>
    );
}
